/* eslint-disable no-unused-vars */
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api"; 

export const place_order = createAsyncThunk(
    'order/place_order',
    async({customerId, customerName, customerEmail, customerPhone, orderType,
        price, products, eventDetailsInfo }) => {
        // console.log('place_order orderType\n', eventDetailsInfo)
        // items, isDeposit, stripePublishableKey, sellerBoolShowPayments
        // backend const {customerId, customerName, customerEmail, customerPhone, 
        // price, products, eventDetailsInfo} = req.body
        try {
           const { data } = await api.post('/home/order/place-order',{
                customerId, customerName, customerEmail, customerPhone, orderType, 
                price, products, eventDetailsInfo})
            //orderId: data.orderId
            //console.log(eventDetailsInfo)
            //console.log(data)            
        } catch (error) {
            console.log(error.response)
        }
    }
)
// End Method 

export const get_customer_orders = createAsyncThunk(
    'order/get_customer_orders',
    async({customerId, status}, { rejectWithValue,fulfillWithValue }) => {
        //console.log(customerId)
        try {
            const {data} = await api.get(`/home/customer/get-customer-orders/${customerId}/${status}`) 
            // console.log('customerId ', customerId)
            // console.log('status ', status)
            // console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const get_customer_latest_order = createAsyncThunk(
    'order/get_customer_latest_order',
    async({customerId}, { rejectWithValue,fulfillWithValue }) => {
        //console.log('customerId ', customerId)
        try {
            const {data} = await api.get(`/home/customer/get-customer-latest-order/${customerId}`) 
            //console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const get_customer_order_details = createAsyncThunk(
    'order/get_customer_order_details',
    async(orderId, { rejectWithValue,fulfillWithValue }) => {
        try {
            const {data} = await api.get(`/home/customer/get-customer-order-details/${orderId}`) 
            // console.log(data)
            return fulfillWithValue(data)
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)
// End Method 

export const orderReducer = createSlice({
    name: 'order',
    initialState:{
        myOrders : [], 
        errorMessage : '',
        successMessage: '',  
        myOrder : {}
    },
    reducers : {
        messageClear : (state,_) => {
            state.errorMessage = ""
            state.successMessage = ""
        }

    },
    extraReducers: (builder) => {
        builder
        .addCase(get_customer_orders.fulfilled, (state, { payload }) => { 
            state.myOrders = payload.orders; 
        })
        .addCase(get_customer_order_details.fulfilled, (state, { payload }) => { 
            state.myOrder = payload.order; 
            //console.log(state.myOrder.eventDetailsInfo)
        })
        .addCase(get_customer_latest_order.fulfilled, (state, { payload }) => { 
            state.myOrder = payload.myOrder; 
            //setState({...state, myOrder: payload.recentOrder})    
            console.log('builder state.myOrder ', state.myOrder) //works
            //console.log(state.myOrder.eventDetailsInfo)
        })
        // .addCase(get_customer_latest_order.fulfilled, (state, { action }) => { 
        //     state.myOrder = action.payload // payload.myOrder; 
        //     //setState({...state, myOrder: payload.recentOrder})
        //     console.log('builder state.myOrder ', state.myOrder) //works
        //     //console.log(state.myOrder.eventDetailsInfo)
        // })
    }
})

export const {messageClear} = orderReducer.actions
export default orderReducer.reducer
